import request from '@/utils/request'
export function policy() {
  return request({
    url:'/aliyun/oss/policy',
    method:'get',
  })
}
export function getTempCredentials() {
  return request({
    url:'/aliyun/oss/getTempCredentials',
    method:'get',
  })
}

export function ossurl(params) {
  return request({
    url:'/aliyun/oss/getoss',    //aliyun/oss/getoss
    method:'get',
    params
  })
}

export function orcidn(params) {
  return request({
    url:'/aliyun/oss/orcidn',    //aliyun/oss/getoss
    method:'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/oss.js